var _g, _g2, _g3, _path, _path2, _path3, _g4, _g5, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSellIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 109,
    viewBox: "0 0 148 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5202_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1563 33.1643L5.09588 75.2916C3.10442 76.4559 3.11726 79.3384 5.11901 80.4848L42.4725 101.878C44.3321 102.943 46.6186 102.935 48.4711 101.858L120.892 59.7354C122.893 58.5715 122.878 55.6758 120.864 54.5331L83.1461 33.1259C81.2854 32.0699 79.0033 32.0846 77.1563 33.1643Z",
    fill: "#9EBCFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5202_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1563 18.7112L5.09588 60.8385C3.10442 62.0027 3.11726 64.8852 5.11901 66.0317L42.4725 87.4247C44.3321 88.4897 46.6186 88.4821 48.4711 87.4046L120.892 45.2823C122.893 44.1184 122.878 41.2226 120.864 40.08L83.1461 18.6728C81.2854 17.6168 79.0033 17.6314 77.1563 18.7112Z",
    fill: "#BCD1FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5202_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1563 5.60571L5.09588 47.733C3.10442 48.8973 3.11726 51.7798 5.11901 52.9262L42.4725 74.3192C44.3321 75.3843 46.6186 75.3766 48.4711 74.2992L120.892 32.1768C122.893 31.0129 122.878 28.1172 120.864 26.9745L83.1461 5.56734C81.2854 4.51134 79.0033 4.52596 77.1563 5.60571Z",
    fill: "url(#paint0_linear_5202_13092)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0229 16.8008L23.8643 44.9395V51.8713L42.2152 60.8428H52.8178L102.161 31.8894V26.5881L85.0336 16.8008H74.0229Z",
    fill: "#E6EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0449 51.3242L48.8965 45.916",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1562 31.4199L83.0078 26.0117",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5202_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.186 30.666L46.9712 23.291L90.4986 46.9507C92.1085 47.8258 93.1108 49.5114 93.1108 51.3437V76.0918L79.342 83.9597V59.153C79.342 57.3518 78.3732 55.6898 76.8059 54.8022L34.186 30.666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 94.2204,
    y: -0.388047,
    width: 52.8,
    height: 54.1195
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#bgblur_0_5202_13092_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5202_13092)",
    "data-figma-bg-blur-radius": 2.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.62,
    cy: 26.012,
    r: 23.76,
    fill: "url(#paint1_linear_5202_13092)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.987 14.9074C129.02 13.8749 130.694 13.8749 131.726 14.9074C132.759 15.9401 132.759 17.6149 131.726 18.6476L124.361 26.0128L131.726 33.3781C132.759 34.4108 132.759 36.0856 131.726 37.1183C130.693 38.151 129.019 38.151 127.986 37.1183L120.621 29.7531L113.256 37.1183C112.223 38.151 110.548 38.151 109.515 37.1183C108.483 36.0856 108.483 34.4107 109.515 33.3781L116.881 26.0128L109.515 18.6476C108.483 17.6149 108.483 15.9401 109.515 14.9074C110.548 13.8746 112.223 13.8746 113.256 14.9074L120.621 22.2726L127.987 14.9074Z",
    fill: "#4C95FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5202_13092",
    x: 1.60986,
    y: 30.3438,
    width: 126.774,
    height: 78.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5202_13092",
    x: 1.60986,
    y: 15.8906,
    width: 126.774,
    height: 78.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5202_13092",
    x: 1.60986,
    y: 2.78516,
    width: 126.774,
    height: 78.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5202_13092",
    x: 32.186,
    y: 21.291,
    width: 66.9248,
    height: 68.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5202_13092",
    x: 94.2204,
    y: -0.388047,
    width: 52.8,
    height: 54.1195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5202_13092_clip_path",
    transform: "translate(-94.2204 0.388047)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.62,
    cy: 26.012,
    r: 23.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5202_13092",
    x1: 63.0127,
    y1: 3.86133,
    x2: 63.0127,
    y2: 76.0403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2E2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5202_13092",
    x1: 96.8604,
    y1: 22.052,
    x2: 147.35,
    y2: 37.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSellIllustration);
export default __webpack_public_path__ + "static/media/noSellIllustration.f100aac7df4e5560886d3a1e7e70f5d6.svg";
export { ForwardRef as ReactComponent };